.tabs {
  :global(.mantine-Tabs-list)::before {
    /* The page-level tabs underline is drawn by the PageHeader full-bleed track
       Box (see PageHeader.tsx), which spans the full content width in the
       #a7a7a7 grid color. The list's own ::before pseudo is suppressed so the
       two don't stack into a doubled hairline. */
    border: 0;
  }

  :global(.mantine-Tabs-tab) {
    border-color: transparent;
    border: none;
    font-size: var(--mantine-font-size-xs);
    position: relative;

    &:hover {
      border-color: transparent;
      background-color: transparent;
    }

    &[data-active="true"] {
      /* biome-ignore lint/complexity/noImportantStyles: Needed to override the default color */
      color: var(--tabs-color, var(--mantine-color-green-6)) !important;
    }
  }
}

/* pinHeader: keep the title/actions header and the tab strip fixed while the
   content below scrolls. The app shell wraps every page in one scroll area, so
   rather than fight that height chain we pin the top block with position:sticky
   — it rides the top of the app-shell scroll viewport as the body scrolls under
   it. The opaque background stops scrolling content showing through, and the
   stacking context keeps it above that content. Inert without pinHeader. */
.pinnedTop {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--mantine-color-body);
}
